import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

// Entrada por SSO (ex.: botão "Marketing + Site" no painel do restaurante).
// Troca o código curto da URL por uma sessão e grava igual ao login
// (token + user no localStorage); depois recarrega no dashboard para o
// AuthProvider/ProjectContext carregarem a conta nova do zero.
const SsoPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false); // o código é de uso único: não trocar duas vezes (StrictMode)

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    // destino opcional (só caminho interno: começa com / e não com //)
    const nextRaw = params.get('next') || '';
    const next = /^\/(?!\/)/.test(nextRaw) ? nextRaw : '/dashboard';
    // tira o código da barra de endereço / histórico
    window.history.replaceState(null, '', '/sso');
    if (!code) {
      setError('Link de acesso incompleto.');
      return;
    }

    (async () => {
      try {
        const { data } = await api.post('/auth/sso-exchange', { code });
        if (!data?.success || !data?.data?.token) throw new Error(data?.message || 'Falha no acesso');
        // outra conta pode estar logada neste navegador: limpa o projeto selecionado
        localStorage.removeItem('currentProjectId');
        localStorage.setItem('token', data.data.token);
        localStorage.setItem('user', JSON.stringify(data.data.user));
        window.location.replace(next);
      } catch (e: any) {
        const status = e?.response?.status;
        const msg = e?.response?.data?.message;
        if (e?.response?.data?.suspended) setError('Sua conta do Marketing está suspensa. Regularize o plano no painel do restaurante.');
        else if (status === 401) setError(msg || 'Este link de acesso expirou ou já foi usado.');
        else setError(msg || 'Não foi possível entrar agora. Tente novamente em instantes.');
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="w-full max-w-md text-center">
        {!error ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
            <p className="mt-4 text-gray-600 dark:text-gray-400">Entrando na sua conta...</p>
          </>
        ) : (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Não foi possível entrar</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">{error}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              Volte ao painel do restaurante e clique em "Marketing + Site" de novo para gerar um link novo.
            </p>
            <Link
              to="/login"
              className="inline-block px-5 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700"
            >
              Entrar com e-mail e senha
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default SsoPage;
